export default __webpack_public_path__ + "static/media/ARTIST-09 (1-1).23cdd9c5.jpg";